import { observer } from 'mobx-react'

import PaywallModal from 'modules/core/components/PaywallModal'
import { Subscription } from 'modules/core/hooks/useCurrentSession'

interface Props {
  onClose?: () => void
  subscription: Subscription
}

const ExpiredTrialChecker = (props: Props & React.ComponentProps<typeof PaywallModal>) => {
  if (props.subscription.inExpiredFreeTrial) {
    return <PaywallModal {...props} />
  }

  return <>{props.children}</>
}

export default observer(ExpiredTrialChecker)
